(function($) {
    var sectionDividerTemplate = null;
    
    var replaceSectionTitle = function(selector) {
        var $section = $(selector);
        
        for (var index = 0; index < $section.length; index++) {
            var sectionTitle = '';
            var sectionDescription = null;
            var $sectionItem = $($section[index]);
            var sectionSpan = $sectionItem.find('span')[0];
            var sectionSmall = $sectionItem.find('small')[0];

            if (!!sectionSpan) {
                sectionTitle = sectionSpan.innerHTML;
                var firstCharacter = sectionTitle.substr(0, 1);
                sectionTitle = firstCharacter.toUpperCase() + sectionTitle.substring(1);
            }
            
            if (!!sectionSmall) {
                sectionDescription = sectionSmall.innerHTML;
            }
            
            $sectionItem.replaceWith(Mustache.to_html($('#sectionDividerTemplate').html().trim(), {title : sectionTitle, description : sectionDescription}));
        }
    };

    var replaceMethodButton = function(selector) {
        var $methodButton = $(selector);
        
        for (var index = 0; index < $methodButton.length; index++) {
            var $methodButtonItem = $($methodButton[index]);
            $methodButtonItem.replaceWith(Mustache.to_html($('#methodButtonTemplate').html().trim(), {methodClass : $($methodButtonItem[0]).attr('class'), text : $methodButtonItem[0].innerHTML}));
        }
    };
    
    var moveModelToggles = function(selector) {
        var modelToggles = $(selector);

        for (var index = 0; index < modelToggles.length; index++) {
            var $modelToggle = $(modelToggles[index]);
            var $model = $modelToggle.closest('.model');
            $model.prepend($modelToggle);
        }
    };

    var initializeDocumentation = function(swaggerJSON, options) {
        var swaggerUI = SwaggerUIBundle({
            spec: swaggerJSON,
            dom_id: '#swagger-ui',
            deepLinking: false,
            docExpansion: !!options && !!options.docExpansion ? options.docExpansion : 'list',
            presets: [
                SwaggerUIBundle.presets.apis,
                SwaggerUIStandalonePreset
            ],
            plugins: [
                SwaggerUIBundle.plugins.DownloadUrl
                ],
          layout: "StandaloneLayout"
        });
        
        // this allows us to wait until the Swagger UI DOM elements are on the page
        $('.opblock-tag').ready(function() {
            replaceSectionTitle('.opblock-tag');
            replaceSectionTitle('.models h4');
            replaceMethodButton('span.opblock-summary-method');
            $('.section-divider .fa-chevron-right').on('click', toggleSectionDisplay);
            moveModelToggles('.model-toggle');
            
            // add a click handler for when the models tab, next to the Example Value tab, is clicked
            $('body').on('click', '.tablinks[data-name="model"]', function(event) {
                setTimeout(function() {
                    moveModelToggles('.col .model-toggle');
                }, 0); // we use setTimeout so that the function gets added to the end of the event queue, this way the swagger click
                // handler can execute and add the dom elements before our function gets called.
            });
            
            // add a click handler for models within models
            $('body').on('click', '.model-toggle', function(event) {
                setTimeout(function() {
                    moveModelToggles('.model-toggle');
                }, 0); // we use setTimeout so that the function gets added to the end of the event queue, this way the swagger click
                // handler can execute and add the dom elements before our function gets called.
            });
            
            // add a click handler for when the API summary is clicked
            $('body').on('click', '.opblock-summary', function() {
                // remove parameter divs with nothing but comments in them, to eliminate extra padding.
                setTimeout(function() {
                    var divs = $('.swagger-ui .parameters .parameters-col_name > div');
                    var contents = divs.contents();
                    
                    for (var index = 0; index < contents.length; index++) {
                        var content = contents[index];
                        
                        if (content.nodeType === Node.COMMENT_NODE) {
                            $(content).remove();
                        }
                        
                        var value = content.nodeValue;
                    
                        if (!!value) {
                            content.nodeValue = value.trim();
                        }
                    }
                    //This is a silly hack to make all of the model tabs display by default
                    //We have to use this because our version of swagger doesn't support the defaultModelRendering: "model" parameter
                    //We simply click all of the tab toggles when the resource is opened
                    var model = $('.tablinks[data-name="model"]');
                    if(!!model){
                    	$.each(model, function(i){
                    		model[i].click()
                    	});
                    }
                    
                }, 0); // we use setTimeout so that the function gets added to the end of the event queue, this way the swagger click
                // handler can execute and add the dom elements before our function gets called.
            });
            
            //Remove error section if visible (this appears in IE 11)
	        var $errorsWrapper = $('.errors-wrapper');
	        
	        if($errorsWrapper.is(':visible')){
	        	$errorsWrapper.hide();
	        }
	        //hide the webhooks endpoints section since users can't use them
        	$(".opblock-tag-section:contains('Webhooks')").hide();
        });
    }
    
    var toggleSectionDisplay = function() {
        $(this).toggleClass('fa-rotate-90');
        $(this).parent().next('div').slideToggle(250);
    };
    
    $(document).ready(function() {
        var swaggerDescriptionData = descriptionData;
        var swaggerRequiredValuesData = requiredValuesData;
        var swaggerJSON = ispwData;
        swaggerJSON.info.title = 'Compuware Enterprise Services REST APIs';
        swaggerJSON.host = 'localhost:48312';
        swaggerJSON.basePath = '/compuware/ws/';
        
        //remove deprecated endpoints so they won't be displayed
        delete swaggerJSON.paths['/{srid}/assignments/{assignmentId}/tasks/generations'];
        delete swaggerJSON.paths['/{srid}/releases/{releaseId}/tasks/generations'];
        
        //remove webhooks paths
        delete swaggerJSON.paths['/webhooks'];
        
        //remove the webhooks models
        delete swaggerJSON.definitions['HCIData'];
        delete swaggerJSON.definitions['HCIWebhookWrapper'];
        delete swaggerJSON.definitions['HttpRequest'];
        delete swaggerJSON.definitions['TriggerApplication'];
        delete swaggerJSON.definitions['TriggerEventName'];
        delete swaggerJSON.definitions['TriggerLevel'];
        delete swaggerJSON.definitions['TriggerOperation'];
        delete swaggerJSON.definitions['Webhook'];
        delete swaggerJSON.definitions['WebhookProduct'];
        delete swaggerJSON.definitions['WebhookTriggerResponse'];
        
        // Add additional description data
        $.extend(true, swaggerJSON, swaggerDescriptionData, swaggerRequiredValuesData);
        
        // make sure all of the methods belong to a high-level group; a.k.a tags in Swagger
        for (var key in swaggerJSON.paths) {
            var arr = key.split('/');
            arr.shift();
            
            Object.keys(swaggerJSON.paths[key]).forEach(function(methodName) {
                // if the method doesn't have a tag then create a tag based on the first part of the path
                if (!swaggerJSON.paths[key][methodName].tags) {
                    swaggerJSON.paths[key][methodName].tags = [arr[0]];
                }
            });
            
            if (key.indexOf('{srid}') >= 0 || key.indexOf('/webhooks') === 0) {
                swaggerJSON.paths['/ispw' + key] = swaggerJSON.paths[key];
                delete swaggerJSON.paths[key];
            }
        }
        
       initializeDocumentation(swaggerJSON);
        
       window.onbeforeprint = function() {
            initializeDocumentation(swaggerJSON, {docExpansion: 'full'});
        };

        window.onafterprint = function() {
            initializeDocumentation(swaggerJSON);
        };
    });
})(jQuery);
